// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".redeem-error .wrapper {\n  max-width: 60%;\n}\n\n.redeem-error p {\n  margin-top: 1rem;\n  margin-bottom: 0;\n}\n\n.redeem-error .redeem-error-heading {\n  font-weight: 700;\n  font-size: 1.25rem;\n  margin-top: 0;\n}\n\n.redeem-error button {\n  margin-top: 2rem;\n}\n\n@media screen and (max-width: 500px) {\n  .redeem-error .redeem-error-heading {\n    font-size: 0.875rem;\n  }\n  .redeem-error .wrapper {\n    max-width: unset;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
